import { Box, styled } from '@mui/material';

export const StyledAppointmentsBookingItemWrap = styled(Box)(() => ({
	height: '100%',
	paddingInline: '4px',
	borderRadius: '3px',
	cursor: 'pointer',
	display: 'flex',
	alignItems: 'center',
	WebkitTapHighlightColor: 'transparent',
}));

export default StyledAppointmentsBookingItemWrap;
